<template>
  <div class="content-card" :class="{ 'cursor-pointer': is_completed }" @click="is_completed && $emit('open')">
    <div class="content-card-media" :style="{ aspectRatio: aspect_ratio.replace(':', ' / ') }">
      <!-- Completed -->
      <template v-if="is_completed && asset">
        <video v-if="job.asset_type === 'video'" :src="asset.url" class="content-media" muted loop playsinline preload="metadata"
          @mouseenter="$event.target.play()" @mouseleave="$event.target.pause()"></video>
        <img v-else :src="asset.url" class="content-media" alt="" />
      </template>

      <!-- Base image of a video while it is processed -->
      <img v-else-if="preview && !is_failed" :src="preview.url" class="content-media content-media-preview" alt="" />

      <!-- Failed / cancelled -->
      <div v-if="is_failed" class="content-card-state content-card-failed">
        <feather-icon icon="AlertCircleIcon" size="22"></feather-icon>
        <span>{{ failed_text }}</span>
        <small>{{ $t('ia.contents.notCharged') }}</small>
      </div>

      <!-- In progress -->
      <div v-else-if="!is_completed" class="content-card-state" :class="{ 'content-card-state-overlay': preview }">
        <b-spinner small></b-spinner>
        <span>{{ progress_text }}</span>
      </div>

      <b-badge class="content-card-type" variant="dark">
        <feather-icon :icon="job.asset_type === 'video' ? 'VideoIcon' : 'ImageIcon'" class="mr-25"></feather-icon>
        {{ job.asset_type === 'video' ? $t('ia.contents.video') : $t('ia.contents.image') }}
      </b-badge>
    </div>
  </div>
</template>

<script>
import { BSpinner, BBadge } from "bootstrap-vue";
import { mainAsset } from './contents-utils';

export default {
  name: 'ContentCard',
  components: {
    BSpinner,
    BBadge,
  },
  props: {
    job: {
      type: Object,
      required: true,
    },
    // Intermediate job (base image) a video depends on
    dependency: {
      type: Object,
      default: null,
    },
    preview: {
      type: Object,
      default: null,
    },
    aspect_ratio: {
      type: String,
      default: '9:16',
    },
  },
  computed: {
    asset() {
      return mainAsset(this.job);
    },
    is_completed() {
      return this.job.status === 'completed';
    },
    is_failed() {
      return ['failed', 'cancelled'].includes(this.job.status);
    },
    failed_text() {
      if (this.job.status === 'cancelled') return this.$t('ia.contents.jobCancelled');
      return this.job.error || this.$t('ia.contents.jobFailed');
    },
    progress_text() {
      if (this.job.status === 'pending') {
        if (this.job.asset_type === 'video' && this.dependency && this.dependency.status !== 'completed') {
          return this.$t('ia.contents.generatingBaseImage');
        }
        return this.$t('ia.contents.jobPending');
      }
      return this.job.asset_type === 'video' ? this.$t('ia.contents.generatingVideo') : this.$t('ia.contents.generatingImage');
    },
  },
};
</script>

<style lang="scss" scoped>
.content-card {
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: #f3f2f7;

  &.cursor-pointer:hover .content-media {
    transform: scale(1.03);
  }
}
.content-card-media {
  position: relative;
  width: 100%;
  overflow: hidden;

  .content-media {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 300ms ease;
  }
  .content-media-preview {
    filter: blur(1px) brightness(0.85);
  }
}
.content-card-state {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  text-align: center;
  color: #6e6b7b;
  font-size: 0.85rem;

  &.content-card-state-overlay {
    color: #fff;
    background: rgba(0, 0, 0, 0.25);
  }
  &.content-card-failed {
    color: #ea5455;
    background-color: #fcecec;

    small {
      color: #6e6b7b;
    }
  }
}
.content-card-type {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  opacity: 0.85;
}
</style>
